import { MOCK_ALL_APIS } from "@/constants"
import { Component } from "@/types/types"
import Script from "next/script"

export const presets = {}

export interface Props extends Component {}

export function OneTrustLoader() {
  const testMode = process.env.NODE_ENV !== "production"

  if (MOCK_ALL_APIS) {
    return null
  }

  return (
    <>
      <Script
        src={`https://cdn.cookielaw.org/consent/0190941e-1838-7edc-b9c3-9a5c858d0fe0${testMode ? `-test` : ``}/OtAutoBlock.js`}
        type="text/javascript"
        strategy="beforeInteractive"
        id="onetrust-1"
      />
      <Script
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        type="text/javascript"
        data-domain-script={`0190941e-1838-7edc-b9c3-9a5c858d0fe0${testMode ? `-test` : ``}`}
        strategy="beforeInteractive"
        id="onetrust-2"
      />
      <Script
        type="text/javascript"
        dangerouslySetInnerHTML={{ __html: `function OptanonWrapper() { }` }}
        strategy="beforeInteractive"
        id="onetrust-3"
      />
    </>
  )
}
